import React from 'react';
import auth from 'works/legacy/lib/auth';
import { AppContent } from '@common/components';
import { setBreadcrumbs } from 'works/legacy/lib/client-store';
import { generateGreetings } from 'works/legacy/lib/date-helper';
import { LastVisitedPageSection } from './_last-visited-page-section';
import { QuickArticlesSection } from './_quick-articles-section';

function parseFirstName() {
  return auth.name()?.split(' ')[0];
}

export function HomePage() {
  const firstName = parseFirstName();
  setBreadcrumbs([
    {
      name: `${generateGreetings()}, ${firstName}.`,
      path: '/works',
      privateInfo: true,
    },
  ]);

  return (
    <>
      <AppContent>
        <div className="home-page">
          <main>
            <section>
              <LastVisitedPageSection />
            </section>
            <section>
              <QuickArticlesSection />
            </section>
          </main>
        </div>
      </AppContent>
      <style jsx>{`
        .home-page {
          width: 800px;
          max-width: 800px;
          min-width: 800px;
          margin-left: auto;
          margin-right: auto;
        }

        @media screen and (min-width: 1326px) {
          .home-page {
            width: 1200px;
            max-width: 1200px;
            min-width: 1200px;
          }
        }

        .home-page section {
          padding-top: 24px;
        }
      `}</style>
    </>
  );
}
